import benefits from 'assets/images/signUp/benefits.png';
import OptaviaLogo from 'assets/images/signUp/optavia-logo.svg?react';

const OptaviaBenefitsCard = () => {
  return (
    <div className="optavia-banner">
      <div className="flex gap-[9px]">
        <OptaviaLogo />
        <img alt="sign" className="h-[38px] w-24" src={benefits} />
      </div>
      <div className="text-mBase font-bold md:text-lg">
        LifeMD clinical oversight to enhance OPTAVIA Weight Management results.
      </div>
      <div className="h-0 border border-white/20"></div>
      <div className="flex h-[77px] flex-col items-start justify-start gap-1">
        <div className="text-mSm font-bold md:text-lg">1. Kick-start Your Weight Loss Result</div>
        <div className="text-mSm">
          Take control of your weight loss with effective medications and expert clinical guidance
          to help you achieve your weight loss goals.
        </div>
      </div>
      <div className="flex h-[59px] flex-col items-start justify-start gap-1">
        <div className="text-mSm font-bold md:text-lg">2. Convenient Lab Testing Support</div>
        <div className="text-mSm">
          LifeMD supports your weight loss goals with complimentary weight-related labs.
        </div>
      </div>
      <div className="flex h-[77px] flex-col items-start justify-start gap-1">
        <div className="text-mSm font-bold md:text-lg">3. Clinically Proven Medications</div>
        <div className="text-mSm">
          LifeMD uses clinically-proven medications and your unique metabolic profile to craft your
          weight loss program.
        </div>
      </div>
      <div className="h-0 border border-white/20"></div>
      <div className="flex h-[59px] flex-col items-start justify-start gap-1">
        <div className="text-mSm font-bold md:text-lg">Save 50% off your first 3 months.</div>
        <div className="text-mSm">
          Take control of your weight loss with effective medications and expert clinical guidance.
        </div>
      </div>
    </div>
  );
};

export default OptaviaBenefitsCard;
